import React from "react";
import classes from "./Shared.module.scss";

const email = (props) => {
  return (
    <a className={[classes.Email, classes[props.where]].join(' ')} href="mailto:dockside158@gmail.com">dockside158@gmail.com</a>
  );
}
export default email;